import React, { useState } from "react";
import MilesPointsReferralLogTable from "./MilesPointsReferralLogTable";

function MilesPointsReferralsSection() {
  const [email, setEmail] = useState("");

  const items = [
    {
      image: "/referralSend.png",
      title: "Send an Invite",
      description: "Enter an email or copy your unique referral link.",
    },
    {
      image: "/referralSignup.png",
      title: "They Sign Up",
      description: "Your invited agency registers and activates their account.",
    },
    {
      image: "/referralEarn.png",
      title: "You Earn Points",
      description:
        "Once they complete their first booking, points are added to your account.",
    },
  ];

  const socials = [
    {
      icon: "/socialIconInstagram.svg",
    },
    {
      icon: "/socialIconTwitter.svg",
    },
    {
      icon: "/socialIconLinkedin.svg",
    },
    {
      icon: "/socialIconFacebook.svg",
    },
  ];

  return (
    <div className="mt-4 w-full flex flex-col">
      <div className="w-full flex justify-between">
        {items?.map((item, index) => (
          <div className="w-[30%] flex flex-col items-center " key={index}>
            <img src={item.image} alt="" className="h-24 object-contain mb-4" />
            <span className="font-BrFirmaBold max-w-[80%] text-center flex ">
              {item.title}
            </span>
            <span className="text-sm text-[#6D7C94] max-w-[80%] text-center flex ">
              {item.description}
            </span>
          </div>
        ))}
      </div>
      <div className="w-full flex mt-6 gap-6">
        <div className={Classname.sectionContainer}>
          <div className={Classname.headerContainer}>
            <div className={Classname.headerTextContent}>
              <span className={Classname.title}>Invite by Email</span>
              <span className={Classname.description}>
                Send an invite with your referral link to a travel agency's
                email.
              </span>
            </div>
          </div>

          <div className={Classname.bottomSection}>
            <input
              type="text"
              className={Classname.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="e.g xyz@gmil.com"
            />
            <button className={Classname.button}>Send Invite</button>
          </div>
        </div>
        <div className={Classname.sectionContainer}>
          <div className={Classname.headerContainer}>
            <div className={Classname.headerTextContent}>
              <span className={Classname.title}>Share Your Referral Link</span>
              <span className={Classname.description}>
                Copy and share your unique link.
              </span>
            </div>
            <div className="flex gap-2 items-center">
              {socials.map((social, socialIndex) => (
                <div
                  className="w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center"
                  key={socialIndex}
                >
                  <img
                    src={social.icon}
                    alt=""
                    className="w-6 object-contain"
                  />
                </div>
              ))}
            </div>
          </div>

          <div className={Classname.bottomSection}>
            <div className={Classname.copyInput}>
              www.intraverse.app/referral_489375
            </div>

            <button className={Classname.button}>Copy Link</button>
          </div>
        </div>
      </div>
      <div className="mt-4"></div>
      <MilesPointsReferralLogTable />
    </div>
  );
}

export default MilesPointsReferralsSection;

const Classname = {
  sectionContainer:
    "rounded-lg bg-white p-6 h-44 flex flex-1 flex-col justify-between",
  headerContainer: "flex items-center w-full gap-3 justify-between",
  headerTextContent: "flex flex-col",
  title: "font-BrFirmaBold text-lg",
  description: "text-sm text-[#6D7C94]",
  bottomSection: "w-full flex gap-3 h-12",
  input:
    "flex flex-1 h-full rounded-lg border border-gray-300 bg-white text-sm px-4",
  copyInput:
    "flex flex-1 h-full rounded-lg border-2 border-[#DBDBDB] bg-[#F0F6FC] text-sm px-4 border-dashed items-center",
  button:
    "h-12 w-36 rounded-lg text-white text-sm bg-primary1 flex items-center justify-center",
};
